import { FC } from "react";
import { Box, ButtonBase, Stack, Typography, useTheme } from "@mui/material";

type Props = {
	label: string;
	mode?: 'desktop' | 'mobile';
	animated?: boolean;
	index?: number;
	active?: boolean;
	onClick?: () => void;
};

const NavButton: FC<Props> = ({ label, mode = 'desktop', animated = false, index = 0, active, onClick }) => {
	const theme = useTheme();

	return (
		<ButtonBase
			disableRipple
			className={`nav-button ${active ? 'nav-button-active' : ''} ${animated ? 'animated fadeInUp' : ''}`}
			sx={{
				justifyContent: mode === 'desktop' ? 'flex-start' : 'center',
				width: mode === 'desktop' ? 200 : '100%',
				paddingLeft: mode === 'desktop' ? 5 : 0,
				textAlign: mode === 'desktop' ? 'left' : 'center',
				animationDelay: `${index * 0.05 + 0.2}s`
			}}
			onClick={onClick}
		>
			<Stack direction="row" sx={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}>
				<Box className="nav-button-edge" sx={{ backgroundColor: theme.palette.primary.main, width: 4 }} />
				<Box className="nav-button-gradient" sx={{ width: mode === 'desktop' ? 60 : '30%', backgroundImage: `linear-gradient(to right, #a9227e64, #f0326232, #f6831b00)` }} />
			</Stack>
			<Typography variant="button" className="nav-button-label" color={active ? theme.palette.primary.main : theme.palette.common.white} sx={{ opacity: active ? 1 : 0.8 }}>{label}</Typography>
			{mode === 'mobile' && (
				<Stack direction="row" sx={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}>
					<Box sx={{ width: 'calc(70% - 4px)'}} />
					<Box className="nav-button-gradient" sx={{ width: '30%', backgroundImage: `linear-gradient(to left, #a9227e64, #f0326232, #f6831b00)` }} />
					<Box className="nav-button-edge" sx={{ backgroundColor: theme.palette.primary.main, width: 4 }} />
				</Stack>
			)}
		</ButtonBase>
	);
};

export default NavButton;
